import React from 'react';

import FloatingReportDiscussion from '../../../components/FloatingReportDiscussion';
import {ReportDiscussionContextProvider} from '../../../components/ReportDiscussion/ReportDiscussionContext';
import * as ReportTypes from '../../../state/reports/types';
import {isOwnView} from '../../../state/views/util';
import {FullyConnectedReportTags} from '../FullyConnectedReportTags';
import {useLoadedReportContext} from '../LoadedReportContext';
import * as S from '../ReportPage.styles';
import {ReportPageContent} from '../ReportPageContent';
import {useReportPageContext} from '../ReportPageContext';
import {ReportPageFooter} from '../ReportPageFooter';
import {ReportPageViewContentHeader} from './ReportPageViewContentHeader';
import {ReportPageViewHeader} from './ReportPageViewHeader';

export const ReportPageViewContainer = () => {
  const {projectName, rootReportId, isWBFeaturedReport, isAdmin, viewer} =
    useReportPageContext();
  const {reportViewRef, view} = useLoadedReportContext();

  const viewerOwnsReport = isOwnView(viewer, view);

  return (
    // Must be wrapped in report discussion context provider to render chat bubble
    <ReportDiscussionContextProvider
      reportViewRef={reportViewRef}
      reportServerID={rootReportId}>
      {(!isWBFeaturedReport || isAdmin) &&
        view.type !== ReportTypes.REPORT_DRAFT_VIEW_TYPE && (
          <ReportPageViewHeader viewerOwnsReport={viewerOwnsReport} />
        )}
      {/* Viewing report page CANNOT be wrapped in a div otherwise the
          floating discussion component won't be visible in the UI.
          TODO - find a better way to handle this floating discussion for FC
      */}
      {reportViewRef != null && (
        <FloatingReportDiscussion viewRef={reportViewRef} />
      )}
      <S.ReportPageContainer isViewMode>
        {/* This displays the report title, description, authors, and fully connected report actions */}
        <ReportPageViewContentHeader />
        <ReportPageContent />
        {isWBFeaturedReport && (
          <FullyConnectedReportTags reportId={rootReportId} />
        )}
        <ReportPageFooter projectName={projectName} />
      </S.ReportPageContainer>
    </ReportDiscussionContextProvider>
  );
};
